exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".overlay-positioner-positioner-1DgwFJAtmwr{display:flex;max-width:100%;position:relative}.overlay-positioner-positioner-1DgwFJAtmwr .overlay-positioner-positioned-2MFcOoObmwr{top:100%;left:0}.overlay-positioner-positioner-1DgwFJAtmwr .overlay-positioner-horizontal-1kMFcwZPmwr{left:100%;top:0}.overlay-positioner-positioner-1DgwFJAtmwr .overlay-positioner-overlap-6sRQfT7Pmwr{top:0}.overlay-positioner-positioner-1DgwFJAtmwr .overlay-positioner-overlap-6sRQfT7Pmwr.overlay-positioner-horizontal-1kMFcwZPmwr{left:0}.overlay-positioner-positioner-1DgwFJAtmwr .overlay-positioner-v-center-4mw1DGDamwr{transform:translateY(-50%)}.overlay-positioner-positioner-1DgwFJAtmwr .overlay-positioner-right-iSX0fIRImwr{left:auto;right:0}.overlay-positioner-positioner-1DgwFJAtmwr .overlay-positioner-right-iSX0fIRImwr.overlay-positioner-horizontal-1kMFcwZPmwr{right:100%;left:auto}.overlay-positioner-positioner-1DgwFJAtmwr .overlay-positioner-h-center-6Y7F3B6lmwr{left:auto;right:auto}.overlay-positioner-positioner-1DgwFJAtmwr .overlay-positioner-upward-5aa7duMtmwr{bottom:100%;top:auto}.overlay-positioner-positioner-1DgwFJAtmwr .overlay-positioner-upward-5aa7duMtmwr.overlay-positioner-horizontal-1kMFcwZPmwr{bottom:0}.overlay-positioner-positioner-1DgwFJAtmwr .overlay-positioner-upward-5aa7duMtmwr.overlay-positioner-overlap-6sRQfT7Pmwr{top:auto;bottom:0}.overlay-positioner-positioner-1DgwFJAtmwr .overlay-positioner-upward-5aa7duMtmwr.overlay-positioner-right-iSX0fIRImwr.overlay-positioner-horizontal-1kMFcwZPmwr{top:auto;bottom:0}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"positioner": "overlay-positioner-positioner-1DgwFJAtmwr",
	"positioned": "overlay-positioner-positioned-2MFcOoObmwr",
	"horizontal": "overlay-positioner-horizontal-1kMFcwZPmwr",
	"overlap": "overlay-positioner-overlap-6sRQfT7Pmwr",
	"v-center": "overlay-positioner-v-center-4mw1DGDamwr",
	"vCenter": "overlay-positioner-v-center-4mw1DGDamwr",
	"right": "overlay-positioner-right-iSX0fIRImwr",
	"h-center": "overlay-positioner-h-center-6Y7F3B6lmwr",
	"hCenter": "overlay-positioner-h-center-6Y7F3B6lmwr",
	"upward": "overlay-positioner-upward-5aa7duMtmwr"
};